<div class="card-box clearfix">
	<div class="row">
		<div class="col-sm-12">
			<label >{{TR "Lesezeichen"}}
		</div>
	</div>
	<div class="row">
		<div class="col-sm-12 grid-bookmark">
			{{#SELECT this.currentID}}
			<select id="js-choose-config" data-style="btn btn-sm btn-white {{#if configIsDifferent}}italic{{/if}}" class="selectpicker" name="data_type_select">
				<option value="0">{{TR "Neuer Eintrag"}}</option>
				<optgroup label="{{TR "Öffentlich"}}" {{#if userCanEditPublic}}data-icon="fa fa-unlock"{{/if}}>
				{{#each this.bookmarks}}
					{{#if attributes.public}}
					<option value="{{attributes.id}}">{{attributes.name}}</option>
					{{/if}}
				{{/each}}
				<optgroup label="{{TR "Privat"}}">
				{{#each this.bookmarks}}
					{{#unless attributes.public}}
					<option value="{{attributes.id}}">{{attributes.name}}</option>
					{{/unless}}
				{{/each}}
			</select>
			{{/SELECT}}
			<button class="js-save-configuration btn-white btn-sm"><span><i class="fa fa-cog"></i></span></button>
			{{#if showInfoButton}}<i id="js-description" class="m-l-10 fa fa-info clickable"></i>{{/if}}
		</div>
	</div>
</div>
